export enum ECampaignSubmissionStatus {
  ALL = 'all',
  PASSED = 'passed',
  TO_REVIEW = 'to_review',
  GREAT_MATCH = 'great_match',
  POSSIBLE_MATCH = 'possible_match',
  NOT_A_MATCH = 'not_a_match'
}
